module.exports = __webpack_public_path__ + "img/browserphone.a20056f4.png";